module.exports = __webpack_public_path__ + "static/img/3areaA_16.81bce74.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/3areaA_16.png
// module id = 850
// module chunks = 1